import { Size } from './size'
import { range } from './util'

export class Matrix<T> {
  private readonly xs: readonly number[]
  private readonly ys: readonly number[]
  readonly matrix: T[][] = []

  constructor(readonly size: Size, create: (x: number, y: number) => T) {
    this.xs = range(size.width)
    this.ys = range(size.height)

    for (const y of this.ys) {
      this.matrix[y] = new Array(size.width)
      for (const x of this.xs) {
        this.set(x, y, create(x, y))
      }
    }
  }

  get(x: number, y: number): T {
    return this.matrix[y][x]
  }

  set(x: number, y: number, elem: T) {
    this.matrix[y][x] = elem
  }

  forEach(f: (elem: T, x: number, y: number) => void): void {
    for (const y of this.ys) {
      for (const x of this.xs) {
        f(this.get(x, y), x, y)
      }
    }
  }
}
